import React from "react";
import RoleGuard from "../components/RoleGuard";

/**
 * Wraps a route element with RoleGuard using the central route permission config.
 */
export function withRouteProtection(
  permissionPath: string,
  element: React.ReactNode
): React.ReactElement {
  return (
    <RoleGuard permissionPath={permissionPath}>{element}</RoleGuard>
  );
}
